import { render, staticRenderFns } from "./companyAuthentication.vue?vue&type=template&id=71ae25af&scoped=true&"
import script from "./companyAuthentication.vue?vue&type=script&lang=js&"
export * from "./companyAuthentication.vue?vue&type=script&lang=js&"
import style0 from "./companyAuthentication.vue?vue&type=style&index=0&id=71ae25af&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71ae25af",
  null
  
)

export default component.exports